import React from 'react'
import Modal from './Modal'
import Form from './Form'
import { ClipLoader } from 'react-spinners'

export function FormModal(props){
  const { title, show, rightTitleLabel, size, handleClose } = props
  

  return(
    <Modal size={size} show={show} title={title} handleClose={handleClose} rightTitleLabel={rightTitleLabel}>
      <Form {...props}>{props.children}</Form>
    </Modal>
  )
}